import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";

class AjaxGalleryTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        panTo: PropTypes.func,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            urlDataMap: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false
            });
            self.loadAuthImages(response.data);
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    render() {
        return (
            <div className="feature-details-ajaxgallery">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderGallery()}
                    </div>
                }
            </div>
        );
    }

    loadAuthImages(data) {
        if (data.features) {
            const self = this;
            const cfg = this.props.tab.config;

            data.features.map(item => {
                const url = FeatureUtils.prepareUrl(item, cfg.src);
                if (self.useAuth()) {
                    self.loadImageWithAuth(url, function(datasrc) {
                        const map = self.state.urlDataMap;
                        map[url] = datasrc;
                        self.setState({
                            urlDataMap: map
                        });
                    });
                } else {
                    const map = self.state.urlDataMap;
                    map[url] = url;
                    self.setState({
                        urlDataMap: map
                    });
                }
            });
        }
    }

    renderGallery() {
        if (this.state.data.features) {
            const cfg = this.props.tab.config;
            return (
                <div className="feature-details-ajaxgallery-images">
                    {this.state.data.features.map(f => this.renderItem(f, cfg))}
                </div>
            );
        }
    }

    renderItem(item, cfg) {
        const url = FeatureUtils.prepareUrl(item, cfg.src);
        const map = this.state.urlDataMap;
        if (!map[url]) {
            return null;
        }

        const link = FeatureUtils.prepareUrl(item, cfg.href);
        const img = this.renderImage(map[url], cfg.width, cfg.height, link);
        let caption = null;
        if (cfg.caption) {
            const captionAttribute = cfg.caption;
            const captionContent = item.properties[captionAttribute];
            caption = (<div className="caption">{captionContent}</div>);
        }
        return (
            <div key={item.properties.id}>
                <div className="image">{img}</div>
                {caption}
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(AjaxGalleryTab);
